import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, TextField, Box, Stack } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Edit } from "@mui/icons-material";
import { JobHttpService } from "../../service";
import Done from "core/components/shared/Done";
import Error from "core/components/shared/Error";
import Loading from "core/components/shared/Loading";

function BenefitForm({ id, onEditDone, ...props }) {
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
    const [editingItem, setEditingItem] = useState(null);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (id) {
            setLoading(true);
            JobHttpService.loadBenefit(id)
                .then(item => {
                    setEditingItem(item);
                    for (const key in item) {
                        setValue(key, item[key]);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    setError("Failed to load benefit");
                    setLoading(false);
                });
        }
    }, [id, setValue]);

    const saveChanges = (data) => {
        setError(null);
        setDone(false);
        setLoading(true);

        var body = {
            "id": id ? id : data.id,
            "title": data.title,
        };

        JobHttpService.saveBenefit(body)
            .then(response => {
                setLoading(false);
                setDone(true);
                setError(null);
                if (onEditDone) {
                    onEditDone(response);
                }
            })
            .catch(err => {
                setLoading(false);
                setError("Something went wrong");
            });
    };

    return (
        <Box>
            <form onSubmit={handleSubmit(saveChanges)}>
                <Stack spacing={2}>
                    <TextField
                        fullWidth
                        label="Title"
                        value={watch('title') ?? ""}
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        {...register("title", { required: "Title is required" })}
                        error={!!errors.title}
                        helperText={errors.title?.message}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            startIcon={editingItem ? <Edit /> : <AddIcon />}
                            disabled={loading}
                        >
                            {editingItem ? "Save Changes" : "Add Benefit"}
                        </Button>
                    </Box>
                    {done && <Done />}
                    {error && <Error message={error} />}
                    {loading && <Loading />}
                </Stack>
            </form>
        </Box>
    );
}

export default BenefitForm;
